export default __webpack_public_path__ + "static/media/picture1.3b510434.png";